import React, { useEffect, useState } from 'react';
import { Button, Input, Space, Checkbox  } from 'antd';
import classNames from 'classnames';
import { useLocation, useNavigate } from 'react-router-dom';
import { getQueryString } from 'utils/utils';
import { RefCode, CompanyCode, PmCode, CmCode, LecturerCode } from 'components/TableSearchBox';
import { addNewSearch } from 'utils/utils';
import 'components/TableSearchBox/index.scss';
import { DatePicker } from 'components/atoms'
import moment, { Moment } from 'moment';
import { RangeValue } from 'rc-picker/lib/interface';
import { dateFormat } from 'utils/date-utils';
import { isMobile } from 'react-device-detect';
import { ReloadOutlined } from '@ant-design/icons';
import useStore from 'store';

const cx = classNames.bind('./index.scss');
export interface ProjectSearchBoxProp {}

const ProjectSearchBox = ({}: ProjectSearchBoxProp): React.ReactElement => {
  /* ======================================================
   * hooks
   * ====================================================== */
  const navigate = useNavigate();
  const location = useLocation();
  const auth = useStore((state) => state.auth); 
  /* ======================================================
   * variables
   * ====================================================== */

  /* ======================================================
   * states
   * ====================================================== */
  const [searchInput, setSearchInput] = useState<string>('');
  const [searchMonth, setSearchMonth] = useState<string|undefined>(undefined);
  const [biz, setBiz] = useState<number>();
  const [searchTarget, setSearchTarget] = useState<string|undefined>(undefined);
  const [searchSubject, setSearchSubject] = useState<string|undefined>(undefined);
  const [searchType, setSearchType] = useState<string|undefined>(undefined);
  const [searchPm, setSearchPm] = useState<string|undefined>(undefined);
  const [searchCm, setSearchCm] = useState<string|undefined>(undefined);
  const [searchLecturer, setSearchLecturer] = useState<string|undefined>(undefined);

  /* ======================================================
   * events
   * ====================================================== */
  const onChange = (e) => {
    setSearchInput(e.target.value);
  };

  const onClickReset = (e) => {
    setSearchInput('');
    setSearchMonth(undefined);
    setBiz(0);
    setSearchTarget(undefined);
    setSearchSubject(undefined);
    setSearchType(undefined);
    setSearchPm(undefined);
    setSearchCm(undefined);
    setSearchLecturer(undefined);

    navigate(location.pathname);
  };

  const onSearch = (data: any) => {
    navigate({
      ...location,
      search: addNewSearch(location.search, data),
    });    
  };

  /* ======================================================
   * effects
   * ====================================================== */

  useEffect(() => {
    const historySearch = getQueryString(location.search);
    (historySearch.search)?setSearchInput(historySearch.search):setSearchInput('');
    if (historySearch.searchDateStart) setSearchMonth(historySearch.searchDateStart);
    if (historySearch.biz) setBiz(historySearch.biz);
    if (historySearch.target) setSearchTarget(historySearch.target);
    if (historySearch.lecture_type) setSearchType(historySearch.lecture_type);
    if (historySearch.lecture_subject) setSearchSubject(historySearch.lecture_subject);
    if (historySearch.pm) setSearchPm(historySearch.pm);
    if (historySearch.cm) setSearchCm(historySearch.cm);
    setSearchLecturer(historySearch.lecturer);

  }, [location.search]);

  useEffect(() => {
    if (isMobile && auth && auth.login && auth.login.lecturer_srl) {
      setSearchLecturer(auth.login.lecturer_srl.toString());
      onSearch({ lecturer: auth.login.lecturer_srl.toString(), pageNo: 1 })
    }
  }, [auth]);  


  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <div className={cx('tableSearchBoxWrapper schedule')}>
      {(isMobile) ? (
        <Space direction='vertical'>
          <Space>   
            <DatePicker width='120px' value={searchMonth?moment(searchMonth):undefined} format="YYYY-MM-DD" picker="date" onChange={(value)=>!!value && onSearch({ searchDateStart: moment(value).format("YYYY-MM-DD")})}/>
            <LecturerCode codeValue={(searchLecturer && searchLecturer !== 'A')?searchLecturer:undefined} onChangeSelect={(value)=>onSearch({ lecturer: value, pageNo: 1 })} />
          </Space>  
          <Space>
            <CompanyCode codeValue={biz} onChangeSelect={(value)=>onSearch({ biz: value, pageNo: 1 })} boxSize={'120px'} />
            <RefCode boxSize={'120px'} codeValue={searchSubject} fieldName={'lecture_subject1'} placeholder={'강의주제'} onChangeSelect={(value)=>onSearch({ lecture_subject: value, pageNo: 1 })} />
            <Button onClick={onClickReset} icon={<ReloadOutlined />} />               
          </Space>  
        </Space>
      ) : (
        <Space direction='vertical'>
          <Space>
            <DatePicker width='120px' value={searchMonth?moment(searchMonth):undefined} format="YYYY-MM-DD" picker="date" onChange={(value)=>!!value && onSearch({ searchDateStart: moment(value).format("YYYY-MM-DD")})}/>   
            <LecturerCode codeValue={(searchLecturer && searchLecturer !== 'A')?searchLecturer:undefined} onChangeSelect={(value)=>onSearch({ lecturer: value, pageNo: 1 })} />
            <CompanyCode codeValue={biz} onChangeSelect={(value)=>onSearch({ biz: value, pageNo: 1 })} />
            <RefCode codeValue={searchTarget} fieldName={'lecture_target'} placeholder={'교육대상'} onChangeSelect={(value)=>onSearch({ target: value, pageNo: 1 })} />
            <PmCode codeValue={(searchPm && searchPm !== 'A')?Number(searchPm):undefined} onChangeSelect={(value)=>onSearch({ pm: value, pageNo: 1 })} />          
            <CmCode codeValue={(searchCm && searchCm !== 'A')?Number(searchCm):undefined} onChangeSelect={(value)=>onSearch({ cm: value, pageNo: 1 })} />  
          </Space>
          <Space>
            <RefCode codeValue={searchSubject} fieldName={'lecture_subject1'} placeholder={'강의주제'} onChangeSelect={(value)=>onSearch({ lecture_subject: value, pageNo: 1 })} />
            <RefCode codeValue={searchType} fieldName={'lecture_type1'} placeholder={'강의구분'} onChangeSelect={(value)=>onSearch({ lecture_type: value, pageNo: 1 })} />
            <Input.Search
              className={cx('searchInput')}
              value={searchInput}
              placeholder="프로젝트명을 입력하세요"
              onChange={onChange}
              onSearch={(value)=>onSearch({ search: value, pageNo: 1 })}
              allowClear
            />
            <Button onClick={onClickReset}>
              검색초기화
            </Button>                
          </Space>      
        </Space>
      )}

    </div>
  );
};

export default ProjectSearchBox;
